module.exports = __webpack_public_path__ + "static/img/right_1.35632fa3.jpg";